import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Row, Col, Button } from "react-bootstrap";
import dataServices from "../../apiServices/data.services";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import { Can } from "../../context/AuthProvider";
import { handleValidationError } from "../../components/CommonFunctions";

const AddPlan = () => {
  const [loading, setLoading] = useState(false);
  const alert = useAlert();
  const navigate = useNavigate();
  const initialValues = {
    name: "",
    price: "",
    billing_cycle: "monthly",
    description: "",
    status: "active",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Plan name is required"),
    price: Yup.number().typeError("Price must be a number").required("Price is required"),
    billing_cycle: Yup.string().required("Billing cycle is required"),
    status: Yup.string().required("Status is required"),
  });

  const handleSubmit = (values) => {
    setLoading(true);
    dataServices
      .addPlan(values)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          alert.success("Plan created successfully");
          navigate("/plans");
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 fw-bold text-black">Add Plan</h6>
      </div>
      <Can I="add" this="Plan">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ errors, touched }) => (
            <Form>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="name">Plan Name <span className="text-danger">*</span></label>
                    <Field
                      name="name"
                      type="text"
                      className={`form-control ${touched.name && errors.name ? "is-invalid" : ""}`}
                      placeholder="Enter plan name"
                    />
                    <ErrorMessage name="name" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="price">Price <span className="text-danger">*</span></label>
                    <Field
                      name="price"
                      type="text"
                      className={`form-control ${touched.price && errors.price ? "is-invalid" : ""}`}
                      placeholder="Enter price"
                    />
                    <ErrorMessage name="price" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="billing_cycle">Billing Cycle <span className="text-danger">*</span></label>
                    <Field name="billing_cycle" as="select" className="form-control">
                      <option value="monthly">Monthly</option>
                      <option value="quarterly">Quarterly</option>
                      <option value="yearly">Yearly</option>
                    </Field>
                    <ErrorMessage name="billing_cycle" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="status">Status <span className="text-danger">*</span></label>
                    <Field name="status" as="select" className="form-control">
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Field>
                    <ErrorMessage name="status" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <Field name="description" as="textarea" rows={3} className="form-control" placeholder="Enter description (optional)" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="footer mt-auto">
                  <Button type="submit" disabled={loading} className="btn btn-primary w-100">
                    Save Plan
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Can>
    </div>
  );
};

export default AddPlan;
